<template>
    <section v-if="json" class="page-home" >
        <div class="capper">
            <FeaturedSlides v-if="json.featurePanel"  mode="home" :bgContentArray="json.featurePanel"></FeaturedSlides>
        </div>
        <GridOuter v-if="json.grid" :json="json.grid" section="home" :filtersLinkouts="json.homeCategories"></GridOuter>
    </section>
</template>
<script>
import axios from 'axios'
//import gsap, {} from 'gsap'
//import { SplitText} from 'gsap/SplitText'
import { mapState } from 'vuex'
import FeaturedSlides from "@/components/blocks/FeaturedSlides"
import GridOuter from "@/components/blocks/GridOuter"
//gsap.registerPlugin(SplitText)
export default {
    name: "HomePage",
    components: {
        FeaturedSlides,
        GridOuter
    },
    data () {
        return {
            window: window,
            json: null,
            inPanelTransition: false,
            revealReady:false
        }
    },
    created () {

    },
    computed: {
        ...mapState({
            didInitialSiteTransition: state => state.didInitialSiteTransition
        }),
    },
    mounted () {
        axios.get((`${window.config.apiroot}home/${window.config.craftApiPreviewToken}`))
            .then((res) => {
                this.json = res.data

                if (this.didInitialSiteTransition) {
                    if (!this.inPanelTransition) {
                        setTimeout(this.reveal,10)
                    }
                }

            }).catch(() => {
        })
    },
    watch: {
        didInitialSiteTransition() {
            if (!this.inPanelTransition) {
                this.reveal()
            }

        }
    },
    methods: {
        reveal: async function() {
            this.inPanelTransition = true

            // await new SplitText('.page-home .txt', {
            //     type: 'words, chars',
            //     charsClass: 'txt-split'
            // });

            this.reveal2()
        },
        reveal2 () {

            // let tl = gsap.timeline({
            //     delay:(this.revealReady) ? 0 : 0.25
            // });

            // tl.fromTo('.page-home .txt .txt-split',
            //     {
            //         opacity: 0,
            //     },
            //     {
            //         duration: 0.35,
            //         opacity: 1,
            //         ease: Power3.easeOut,
            //         stagger: 0.007,
            //         onStart:this.revealReadyMethod
            //     },
            //     2
            // )
        },

        revealReadyMethod () {
            this.revealReady = true
        }
    }
}
</script>
<style lang="scss" scoped>
.test {
    margin: 80px 0;
    display: flex;
    justify-content: space-between;
    gap: 40px;
    align-items: stretch;
    img {
        height: 100%;
        width: auto;
        object-fit: contain;
    }
}
</style>
